import { ComponentProps, useEffect, useRef } from "react";

export interface FocusableDivProps extends ComponentProps<'div'> {
  trigger?: any;
  children?: React.ReactNode;
}

const AutoFocusDiv = (props: FocusableDivProps) => {
  const { trigger, children, ...divProps } = props;

  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    (trigger || children) && sectionRef.current?.scrollIntoView();
  }, [trigger, children]);

  return (
    <div {...divProps} ref={sectionRef}>
      {children}
    </div>
  );
};

export default AutoFocusDiv;
